import { definirWorkerDePdf } from '@mymaxx/ui';
import workerDePdf from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { LimiteDeErro } from './componentes/LimiteDeErro';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 10_000 } },
});

// A prévia de PDF precisa saber onde está o worker do pdf.js, e só o empacotador sabe.
// Fica aqui, uma vez, porque `@mymaxx/ui` compila com tsc puro e não entende o `?url` do Vite.
definirWorkerDePdf(workerDePdf);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LimiteDeErro>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </LimiteDeErro>
  </StrictMode>,
);
